import React, { useState } from 'react'
import Title from '../Title';
import UserDetails from '../UserDetails';
import Sidebar from '../AntSideBar/AntSideBar';
import UndoRedoToolbar from '../Undo';
import Board from '../Board';
import { useParams } from "react-router-dom";
import { ChatBox } from '../ChatBox/ChatBox';
import MouseContainer from '../mousecontainer';
import IconBar from "../iconbar"; // css file for styling
import OfflineStatus from '../OfflineStatus';
import { useDocument } from '../../context/documentInfoContex';
import DocumentDataConflictModal from '../ConflictModal';

const MainLayout = () => {

    const { id } = useParams();
    const { isConflictModalVisible, setIsConflictModalVisible, conflictPreviewVerion } = useDocument();
    const isTablet = window.screen.width < 1200 && window.screen.width > 768;
    const isMobile = window.screen.width < 768;
    const url_string = window.location.href;
    const url = new URL(url_string);
    const hideMenu = url.searchParams.get("hideMenu");
    const [contentLoading, setContentLoading] = useState(true);

    return (
        <div>
            {/* <BoardNav /> */}
            {/* <AntNavBar /> */}
            {/* <Header /> */}
            {!contentLoading && !conflictPreviewVerion &&
                <div
                    style={{
                        margin: 20,
                        display: "flex",
                        justifyContent: "space-between",
                    }}
                >
                    <Title isMobile={isMobile} />
                    <UserDetails />
                </div>
            }
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    height: isTablet ? '900px' : '80vh'
                }}
            >
                {!contentLoading &&
                    <div style={{ padding: 20, position: isTablet ? "absolute" : '', top: isTablet ? '110px' : "" }}>
                        {!hideMenu && <Sidebar />}

                        {!hideMenu && <UndoRedoToolbar />}
                    </div>
                }
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
                    {/* <AntSideBar /> */}
                    <Board contentLoading={contentLoading} setContentLoading={setContentLoading} />
                    {/* <AntZoomHandler /> */}
                </div>
            </div>
            {
                !conflictPreviewVerion &&
                <>
                    <ChatBox id={id} />
                    <MouseContainer id={id} />
                </>
            }
            <OfflineStatus />
            <DocumentDataConflictModal
                isConflictModalVisible={isConflictModalVisible}
                setIsConflictModalVisible={setIsConflictModalVisible}
            />
        </div>
    )
}

export default MainLayout;